import { render, staticRenderFns } from "./DesktopSuggestions.vue?vue&type=template&id=4110ef72"
import script from "./DesktopSuggestions.vue?vue&type=script&lang=js"
export * from "./DesktopSuggestions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports